export function BinderCopyActions({title,onConsult,pdfHref}: {
  title:string;
  onConsult:()=>void;
  pdfHref:string;
}) {
  return <div className="student-binder-actions">
    <button onClick={onConsult} aria-label={`Consulter ${title}`}>Consulter</button>
    <a
      className="student-binder-pdf"
      href={pdfHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Ouvrir le PDF de ${title}`}
    >
      PDF
    </a>
  </div>;
}
